module.exports = __webpack_public_path__ + "img/bmarkH5.6a390149.png";